import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import { store } from './store';
import reportWebVitals from './reportWebVitals';

// Monkey patch HTMLMediaElement.prototype.play to catch interrupted errors
if (process.env.NODE_ENV === 'development') {
  const originalPlay = HTMLMediaElement.prototype.play;

  HTMLMediaElement.prototype.play = function() {
    const promise = originalPlay.call(this);

    if (promise && typeof promise.catch === 'function') {
      return promise.catch((error) => {
        if (error.name === 'AbortError' || error.message?.includes('interrupted')) {
          // Silently suppress the error
          return Promise.resolve();
        }
        // Re-throw other errors
        return Promise.reject(error);
      });
    }

    return promise;
  };
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
